export default {
  default: () => import("/tmp/build/ad8838f6/corporate-website-nuxt3-pr/layouts/default.vue"),
  embed: () => import("/tmp/build/ad8838f6/corporate-website-nuxt3-pr/layouts/embed.vue"),
  empty: () => import("/tmp/build/ad8838f6/corporate-website-nuxt3-pr/layouts/empty.vue")
}